import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavigateBefore } from "@mui/icons-material";
import { Checkbox, FormControlLabel, FormGroup, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { isNotUndefinedOrNull } from "../../FunctionsCore";
import ThemeProvider from "../../theme";
import { FONTSTYPO, SPACING } from "../../theme/palette";
import { ButtonStyle, Top } from "./styles";
const resultsContainerWidth = "19.25rem";
const defaultMobileBreakpoint = 992;
const Container = styled("div")(() => ({
    "min-width": resultsContainerWidth
}));
const Group = styled("div")(({ theme }) => ({
    "alignItems": "flexStart",
    "alignSelf": "stretch",
    "boxShadow": `0px -1px 0px 0px ${theme.palette.grey[300]}`,
    "display": "flex",
    "flexDirection": "column",
    "gap": SPACING.space2xs,
    "padding": `${SPACING.space2xs} ${SPACING.spacexs} ${SPACING.spacemL} ${SPACING.spacesM}`
}));
const FilterComponent = (props) => {
    const { mobileBreakpoint = defaultMobileBreakpoint, mobileOpen = false, setMobileFiltersOpen, updateFilter } = props;
    const filterConfig = {
        "groups": [
            {
                "displayName": "Categories",
                "filters": [
                    {
                        "displayName": "Products",
                        "name": "products"
                    },
                    {
                        "displayName": "Solutions",
                        "name": "solutions"
                    },
                    {
                        "displayName": "Resources",
                        "name": "resources"
                    },
                    {
                        "displayName": "Insights",
                        "name": "insights"
                    },
                    {
                        "displayName": "News",
                        "name": "news"
                    },
                    {
                        "displayName": "Partners",
                        "hide": true,
                        "name": "partners"
                    }
                ],
                "name": "category"
            },
            {
                "displayName": "Content Type",
                "filters": [
                    {
                        "displayName": "Use Case",
                        "name": "use case"
                    },
                    {
                        "displayName": "Customer Story",
                        "name": "customer story"
                    },
                    {
                        "displayName": "Reports",
                        "name": "reports"
                    },
                    {
                        "displayName": "Article",
                        "name": "article"
                    },
                    {
                        "displayName": "Guide",
                        "name": "guide"
                    },
                    {
                        "displayName": "eBook",
                        "name": "eBook"
                    },
                    {
                        "displayName": "Video",
                        "name": "video"
                    },
                    {
                        "displayName": "Press Release",
                        "name": "press release"
                    },
                    {
                        "displayName": "Data Set",
                        "hide": true,
                        "name": "data set"
                    },
                    {
                        "displayName": "Score",
                        "hide": true,
                        "name": "score"
                    },
                    {
                        "displayName": "Event",
                        "name": "event"
                    }
                ],
                "name": "contentType"
            },
            {
                "displayName": "Business Type",
                "filters": [
                    {
                        "displayName": "Small Business",
                        "name": "small business"
                    },
                    {
                        "displayName": "Enterprise",
                        "name": "enterprise"
                    },
                    {
                        "displayName": "Public Sector",
                        "name": "public sector"
                    }
                ],
                "name": "businessType"
            },
        ]
    };
    const [filters, setFilters] = useState([]);
    useEffect(() => {
        const filterObject = {
            "and": filters.map((filter) => {
                const filterGroup = filter.slice(0, filter.search("_"));
                const filterName = filter.slice(filter.search("_") + 1);
                return { [`custom_fields.${filterGroup}`]: filterName };
            })
        };
        updateFilter(filterObject);
    }, [filters]);
    const handleFilterChange = (changeEvent) => {
        if (Boolean(changeEvent.target.checked) && !Boolean(filters.find((filter) => filter === changeEvent.target.value))) {
            setFilters([...filters, changeEvent.target.value]);
        }
        else if (Boolean(filters.find((filter) => filter === changeEvent.target.value))) {
            setFilters(filters.filter((filter) => filter !== changeEvent.target.value));
        }
    };
    const clearFilters = () => setFilters([]);
    const closeMobileFilters = () => {
        if (isNotUndefinedOrNull(setMobileFiltersOpen)) {
            setMobileFiltersOpen(false);
        }
    };
    const theme = useTheme();
    const mobile = !useMediaQuery(theme.breakpoints.up(mobileBreakpoint));
    return (_jsx(ThemeProvider, { children: mobileOpen || !mobile ?
            _jsxs(Container, { children: [mobileOpen && mobile ?
                        _jsxs(Top, Object.assign({ sx: {
                                "marginBottom": SPACING.spacem
                            } }, { children: [_jsx(ButtonStyle, Object.assign({ onClick: closeMobileFilters, startIcon: _jsx(NavigateBefore, {}), type: "reset" }, { children: "Back to Search" })), _jsx(ButtonStyle, Object.assign({ disabled: filters.length === 0, onClick: clearFilters, type: "reset" }, { children: "Clear All" }))] }))
                        :
                            _jsx(_Fragment, {}), _jsxs(Top, { children: [_jsx(Typography, Object.assign({ variant: "h5" }, { children: "Filter" })), mobileOpen && mobile ?
                                _jsx(_Fragment, {})
                                :
                                    _jsx(ButtonStyle, Object.assign({ disabled: filters.length === 0, onClick: clearFilters, type: "reset" }, { children: "Clear All" }))] }), _jsx("div", Object.assign({ style: { "marginTop": SPACING.space2xs } }, { children: filterConfig.groups.map(group => (_jsxs(Group, { children: [_jsx(Typography, Object.assign({ variant: "h6" }, { children: group.displayName })), _jsx(FormGroup, Object.assign({ sx: mobile ? {
                                        "display": "grid",
                                        "gridTemplateColumns": "repeat(2, 1fr)"
                                    } : {} }, { children: group.filters.filter(filter => { var _a; return !((_a = filter.hide) !== null && _a !== void 0 ? _a : false); }).map(filter => {
                                        const filterId = `${group.name}_${filter.name}`;
                                        return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: filters.includes(filterId), onChange: (ev => handleFilterChange(ev)), value: filterId }), label: filter.displayName, slotProps: { "typography": { "fontSize": FONTSTYPO.stepMinues1 } } }, filter.name));
                                    }) }))] }, group.name))) }))] })
            :
                _jsx(_Fragment, {}) }));
};
export { FilterComponent };
